/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filters_ClearInputs */



/**
* | output |
* | --- |
* | "Clear filters" |
*
* @param {Filters_ClearInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const filters_clear = /** @type {((inputs?: Filters_ClearInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filters_ClearInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Réinitialiser les filtres")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar filtros")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Limpar filtros")
	if (locale === "it") return /** @type {LocalizedString} */ ("Azzera i filtri")
	return /** @type {LocalizedString} */ ("Clear filters")
});